import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://dryeshjitesh.com';
export const SITE_NAME = 'Dr. Yesh Jitesh';
export const DEFAULT_OG_IMAGE =
  'https://storage.googleapis.com/gpt-engineer-file-uploads/7GQ8GxfR0mdYtMxKF3jXmCIRS1v2/social-images/social-1774555630162-Blue_and_White_Simple_Man_LinkedIn_Profile_Picture_20250915_122550_0000(1).webp';

type SeoProps = {
  /** Full document title, used verbatim. */
  title: string;
  description: string;
  /** Route path beginning with a slash, e.g. "/blog". */
  path: string;
  type?: 'website' | 'profile' | 'article';
  image?: string | null;
  imageAlt?: string;
  keywords?: string;
  noindex?: boolean;
  /** One or more JSON-LD objects rendered as separate script tags. */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

export const Seo = ({
  title,
  description,
  path,
  type = 'website',
  image,
  imageAlt,
  keywords,
  noindex = false,
  jsonLd,
}: SeoProps) => {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_OG_IMAGE;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      {imageAlt ? <meta property="og:image:alt" content={imageAlt} /> : null}
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {imageAlt ? <meta name="twitter:image:alt" content={imageAlt} /> : null}

      {schemas.map((schema, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

/** Breadcrumb JSON-LD for an inner page. */
export const breadcrumbSchema = (items: { name: string; path: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});
